<script>
    export let backbutton = false;
    export let width = '';
</script>

<style>
    button {
        background-color: var(--colorElement);
        color: var(--colorFgInverse);
        font-family: var(--typeFaceVariant);
        font-size: var(--typeSizeLarge);
        letter-spacing: 1px;
        padding: var(--spacingSmall) var(--spacingMedium);
        margin-top: var(--spacingMedium);
        position: relative;
    }

    button.backbutton {
        background-color: var(--colorElementVariant);
    }
</style>

<button {...$$restProps} on:click class:backbutton class="button" style="width: {width}">
    <slot />
</button>
